// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Trophy_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M21.75 6H19.5V4.5a.75.75 0 0 0-.75-.75H5.25a.75.75 0 0 0-.75.75V6H2.25a1.5 1.5 0 0 0-1.5 1.5V9a3.75 3.75 0 0 0 3.75 3.75h.342a7.51 7.51 0 0 0 6.408 5.213v2.287H9a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-2.25v-2.29c2.994-.302 5.479-2.403 6.383-5.21h.367A3.75 3.75 0 0 0 23.25 9V7.5a1.5 1.5 0 0 0-1.5-1.5ZM4.5 11.25A2.25 2.25 0 0 1 2.25 9V7.5H4.5v3q0 .375.037.75Zm13.5-.834c0 3.33-2.719 6.06-6 6.084a6 6 0 0 1-6-6V5.25h12ZM21.75 9a2.25 2.25 0 0 1-2.25 2.25h-.047a8 8 0 0 0 .047-.834V7.5h2.25Z',
  viewBox: '0 0 24 24',
  glyph: 'Trophy_Stroke2_Corner2_Rounded',
})
